var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('top-nav'),_c('sidebar'),_c('v-main',[_c('v-sheet',{staticClass:"pa-8",staticStyle:{"margin-bottom":"200px"},attrs:{"color":"transparent","flat":""}},[_c('router-view')],1),_c('site-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }